export default __webpack_public_path__ + "static/media/es.30eb0364.svg";